import axios from 'axios';
import { DossierId } from '@/dossier/models/AbstractDossier';
import { ContentId } from '@/general/models/MediaFile';
import { JobId } from '@/jobs/models/AbstractJob';
import DossierContactTarget from '@/shared/models/DossierContactTarget';
import { isPresent, present } from '@/shared/utils/typescript';
import { parseChatMessage } from '../converters/chatMessageConverters';
import ChatGroup from '../models/ChatGroup';
import ChatMentionTarget from '../models/ChatMentionTarget';
import ChatMessage from '../models/ChatMessage';
import ChatUser from '../models/ChatUser';
import { ChatId } from '../models/ids';
import parseChatContent from '../utils/parseChatContent';

const TARGET_TYPE = 3;

export default class ChatMessageClient {
  static async sendExternal(chatId: ChatId, content: string | File | ContentId, targets: Array<DossierContactTarget>): Promise<ChatMessage> {
    const formData = new FormData();

    formData.append('chatId', `${chatId}`);

    if (typeof content === 'string') {
      formData.append('content', content);
    } else if (content instanceof File) {
      formData.append('mediaFile', content);
    } else if (isPresent(content)) {
      formData.append('mediaFileId', `${content}`);
    }

    targets.forEach(({ contact, target }, i) => {
      if (isPresent(contact.id)) {
        formData.append(`targets[${i}].dossierContactId`, `${contact.id}`);
      }
      formData.append(`targets[${i}].sentTo`, target);
      const { customer } = contact;
      if (customer) {
        formData.append(`targets[${i}].customerName`, customer.fullName);
        formData.append(`targets[${i}].languageCode`, customer.language);
      }
      formData.append(`targets[${i}].type`, `${TARGET_TYPE}`);
    });

    const response = await axios.post('/api/mobopro/v1/chatmessage', formData);
    return present(parseChatMessage(response.data.message, response.data.chatId));
  }

  static async sendInternal(dossierId: DossierId, content: string, availableTargets: Array<ChatMentionTarget>, jobId?: JobId): Promise<ChatMessage> {
    // this should really be done in the back-end
    const elements = parseChatContent(content, availableTargets);
    const mentionGroups = elements.filter((e): e is ChatGroup => e instanceof ChatGroup).map(g => g.id);
    const mentionOutletUsers = elements.filter((e): e is ChatUser => e instanceof ChatUser).map(u => u.id);

    const data = {
      dossierId,
      content,
      jobId,
      mentionGroups,
      mentionOutletUsers,
    };

    const response = await axios.post('/api/mobopro/v2/internaldialogmessages', data);
    return present(parseChatMessage(response.data.message, response.data.chatId));
  }
}
